import { PanelContent } from "./Content";
import { PanelHeader } from "./Header";
import { Panel as PanelDefault } from "./Panel";

export const Panel = {
  Default: PanelDefault,
  Header: PanelHeader,
  Content: PanelContent,
};
